module.exports = __webpack_public_path__ + "img/04_1.34ab1688.png";